import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'filename'
})
export class FilenamePipe implements PipeTransform {
  transform(val: string): string {
    let strIndex = val.indexOf('_');
    return val.substring(strIndex + 1, val.length);
  }
}



// WEBPACK FOOTER //
// ./src/app/pipe/filename.pipe.ts